import React from 'react';
import { CircularProgress } from '@mui/material';
import Center from '../utils/Center';

const Loader = () => {
  return (
    <Center>
      <CircularProgress color={'primary'} />
    </Center>
  );
};

export default Loader;
